import { cn } from '@core/utils';

import { Image } from '@/components/client';

import { TYPOGRAPHY_IMAGES } from '../../constants';

type ChallengeHeaderProps = {
  className?: string;
};

export const ChallengeHeader = ({ className }: ChallengeHeaderProps) => {
  return (
    <div
      className={cn('flex flex-col items-center gap-6 text-center', className)}
    >
      <p className="font-700 text-Gray-800 typo-h5">
        방방곡곡 지역 기부 챌린지
      </p>
      <h2 id="challenge-heading">
        <Image
          src={TYPOGRAPHY_IMAGES.challengeHeading.url}
          alt={TYPOGRAPHY_IMAGES.challengeHeading.alt}
          width={TYPOGRAPHY_IMAGES.challengeHeading.width}
          height={TYPOGRAPHY_IMAGES.challengeHeading.height}
          loading="lazy"
          className="object-contain"
        />
      </h2>
    </div>
  );
};
